<template>
  <div class="breadcrumb">
    {{ $route.name }}
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped></style>
